import React from 'react';
import { ITransactionsHistoryTable } from './ITransactionHistoryTable';
import { classNames } from '@features/utils/reactFunctions';
import TransactionHistoryTableRow from './components/TransactionHistoryTableRow/TransactionHistoryTableRow';
import OldTransactionHistoryTableRow from './components/OldTransactionHistoryTableRow/OldTransactionHistoryTableRow';
import ITransaction from '@funds/interfaces/ITransaction';
import Pagination from '@appComponents/Pagination/Pagination';

import * as style from './TransactionHistoryTableStyle.module.scss'
import * as elements from '@appStyles/_elements.module.scss';

const TransactionHistoryTable: React.FunctionComponent<ITransactionsHistoryTable> =
  ({ transactions, balance, paginationConfig, filterData }) => {
    const addedClass = [style.zebraTableItemDate, style.zebraTableItemDescription, style.zebraTableItemIn,
      style.zebraTableItemOut, style.balanceBalance];

    const withBalanceClass = [style.balanceDate, style.balanceDescription,
      style.balanceIn, style.balanceOut, ''];

    return (
      <div className={style.transactionsHistory}>
        {
          transactions.length > 0 ? (
            <div className={elements.zebraTableContainer}>
              <div className={elements.zebraTableRow}>
                {['Date', 'Description', 'In', 'Out', balance ? 'Balance' : null]
                  .map((label: string, i) => {
                    return label && (
                    <div
                      key={label}
                      className={
                        classNames(elements.zebraTableItem, style.zebraTableItem,
                          addedClass[i], balance && withBalanceClass[i])
                      }
                    >
                      <span>{label}</span>
                    </div>
                  );
                  })}
              </div>
              {transactions.map((el: ITransaction, index: number) => {
                return process.env.ENABLE_BINANCE_TRADING ? (
                  <TransactionHistoryTableRow
                    balance={balance}
                    transaction={el}
                    key={`${el.transaction_id}_${el.payment_id}_${index}`}
                  />
                ) : (
                  <OldTransactionHistoryTableRow
                    balance={balance}
                    transaction={el}
                    key={`${el.transaction_id}_${el.payment_id}`}
                  />
                );
              })}
            </div>
          ) : <h4 className={classNames(elements.noItems, style.noItems)}>
            No transactions history for selected filters.
          </h4>
        }
        <Pagination
          currentPage={paginationConfig.currentPage || 1}
          totalCount={paginationConfig.totalCount || 0}
          maxPerPage={paginationConfig.perPage || 10}
          filterData={filterData}
        />
      </div>
    );
  };

export default React.memo(TransactionHistoryTable);
